<template>
    <div class="Card--scrollable__container">
        <div>
            <div class="relative h-20" v-if="loading">
                <div class="spinner text-5xl"></div>
            </div>
            <div v-for="message in messages" :key="`message${message.id}`"
                class="max-w-xl mt-4"
                :class="isFromAuth(message) ? 'ml-6 xl:ml-auto text-right' : 'mr-6'"
                >
                <div class="inline-block p-4 py-2 text-left rounded-lg whitespace-pre-wrap break-all"
                    :class="messageClass(message)"
                    v-text="message.text"
                ></div>
                <div class="px-4 text-xs text-muted">
                    {{ message.from.fullName }} &nbsp; {{ message.created_at_diff }}
                </div>
            </div>

            <div class="max-w-xl ml-6 xl:ml-auto mt-4">

                <textarea
                    v-model="data.text"
                    @keyup="error = false"
                    class="p-4 max-w-xl rounded-lg rounded-tr-none bg-gray-300"
                    placeholder="Sem napište odpověď"
                ></textarea>
                <div class="form__error relative inline-block" v-if="error" v-text="errorMessage" >Zadané údaje nejsou platné</div>

                <div class="mt-2 text-right">

                    <a v-if="backUrl" :href="backUrl" class="btn">
                        <icon name="chevron-left"/>
                        Zpět
                    </a>

                    <btn class="btn btn--primary"
                        @click.prevent.native="onSubmit()"
                        :loading="sending"
                        :disabled="sending || error"
                    >
                        Odeslat
                        <icon name="chevron-right"/>
                    </btn>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        id: {
            required: true,
            type: Number
        },
        backUrl: {
            type: String
        }
    },

    data() {
        return {
            messages: [],
            data: {},
            sending: false,
            loading: true,
            error: false,
            errorMessage: null
        }
    },

    methods: {

        isFromAuth(message) {
            return window.App.auth
                && window.App.auth.id == message.from_user_id;
        },

        messageClass(message) {
            if (message.log) {
                return 'rounded-xl bg-gray-600 text-gray-200 italic';
            }

            if (this.isFromAuth(message)) {
                return 'bg-gray-300 rounded-tr-none';
            } else {
                return 'bg-accented text-white rounded-tl-none';
            }
        },

        loadMessages() {
            axios.get(url(`/conversations/${this.id}?ajax`)) // the "?ajax" prevents displaying json in browser after using back/forward buttons
                .then(response => {
                    this.messages = response.data.messages;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(errors.response);
                    alert('unexpected error');
                });
        },

        scrollToBottom() {
            let container = this.$el;
            container.scroll({
                top: container.scrollHeight,
                left: 0,
                behavior: 'smooth'
            });
        },

        onSubmit() {
            this.sending = true;

            axios.post(url(`/conversations/${this.id}`), this.data)

                .then(response => {
                    this.sending = false;
                    // this.messages.push(response.data.message);
                    this.data.text = '';

                    Notify.info('Zpráva byla odeslána');
                })

                .catch(errors => {
                    this.sending = false;

                    if (errors.response.status !== 422) {
                        console.log(errors.response);
                        alert('unexpected error');
                        return;
                    }

                    this.errorMessage = errors.response.data.errors.text[0];
                    this.error = true;
                });
        },

        clearQueuedNotifications() {
            axios.patch(url(`/conversations/${this.id}/clear-queued-notification`));
        }
    },

    mounted() {

        this.loadMessages();

        window.Echo.channel(`conversation.${this.id}`)
            .listen('MessageCreated', (e) => {
                this.messages.push(e.message);
                if (! this.isFromAuth(e.message)) {
                    this.clearQueuedNotifications();
                    Notify.info(`Nová zpráva od ${e.message.from.fullName}`);
                }
            });

    },

    updated() {
        this.$nextTick(() => this.scrollToBottom());
    }
}
</script>
